export const XS_MOBILE_SCREEN = 500;
export const MOBILE_SCREEN = 768;
export const TABLET_SCREEN = 1024;
export const QHD_SCREEN = 2048;
